<div class="wrap p-l-0-l p-l-0-x p-r-0-l p-r-0-x">
    <div class="flex">
        <div class="left-column pos-relative">
            <store-finder #storeFinder
                          (storesUpdate)="onStoresUpdate($event)"
                          class="fill-x fill-l flex p-l-5 p-r-5 p-t-5 p-t-5-s p-t-5-m p-l-0-s p-l-0-m p-r-0-s p-r-0-m" />
        </div>
        <div class="flex-grow pos-relative right-column ratio-5-4"
             *ifSize="'XL'">
            <google-map class="fill"
                        [fitBounds]="true"
                        [stores]="stores"
                        (storeSelected)="onStoreMarkerClicked($event)"
                        [markerLimit]="1000" />
        </div>
    </div>
</div>
